module.exports = __webpack_public_path__ + "static/media/MultipleCompany.a94ca9cf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Svg/MultipleCompany.svg
// module id = 1369
// module chunks = 0